
import React from 'react';
import { Trash2 } from 'lucide-react';

export const TrashIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <Trash2 strokeWidth={1.5} {...props} />
);
